import { gql } from '@apollo/client';

export const fragments = {
  all: gql`
    fragment SuperUserData on User {
      id
      name
      email
      superRole
      dateCreated
      lastLogin
      subscribedToNotifications
      lockdown
      hasPassword
    }
  `,
};

export const list = gql`
  query users {
    users {
      ...SuperUserData
    }
  }
  ${fragments.all}
`;

export const superUsersPaginatedQuery = gql`
  query usersPaginated($offset: Int, $limit: Int, $sortBy: String, $sortOrder: String, $name: String, $role: String) {
    usersPaginated(offset: $offset, limit: $limit, sortBy: $sortBy, sortOrder: $sortOrder, name: $name, role: $role) {
      ...SuperUserData
    }
  }
  ${fragments.all}
`;

export const superUsersCountQuery = gql`
  query usersCount {
    usersCount
  }
`;

export const superUsersCountFilteredQuery = gql`
  query usersCountFiltered($name: String, $role: String) {
    usersCountFiltered(name: $name, role: $role)
  }
`;

export const item = gql`
  query user($id: Long!) {
    user(id: $id) {
      ...SuperUserData
    }
  }
  ${fragments.all}
`;

export const create = gql`
  mutation createUser($name: String!, $email: String!, $role: EUserRole!) {
    createSuperUser(name: $name, email: $email, role: $role) {
      ...SuperUserData
    }
  }
  ${fragments.all}
`;

export const update = gql`
  mutation editUser($id: Long!, $name: String, $email: String, $role: EUserRole, $subscribeToNotifications: Boolean) {
    editSuperUser(
      id: $id
      name: $name
      email: $email
      role: $role
      subscribeToNotifications: $subscribeToNotifications
    ) {
      ...SuperUserData
    }
  }
  ${fragments.all}
`;

export const remove = gql`
  mutation deleteUser($id: Long!) {
    deleteUser(id: $id)
  }
`;

export default {
  list,
  item,
  create,
  update,
  remove,
};
